<template>
    <div v-loading="loading">
        <el-button v-if="tableShow"
            @click="exportxls()"
            icon="el-icon-download"
            size="small"
            style="margin-bottom: 15px; float: right;"
            type="primary">
            一键导出
        </el-button>
        <my-table :data="tableData" height="500px" v-if="tableShow">
            <el-table-column label="文件名称" prop="filename" min-width="180"></el-table-column>
            <el-table-column label="文件编码" prop="zbfilecode" min-width="140"></el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="180"></el-table-column>
            <el-table-column label="投标人名称" prop="dwname" min-width="140"></el-table-column>
            <el-table-column label="联系人" prop="username" min-width="120"></el-table-column>
            <el-table-column label="联系方式" prop="truename" min-width="140"></el-table-column>
            <el-table-column label="下载次数" prop="ip" min-width="140"></el-table-column>
        </my-table>

        <my-pagination 
            ref="page" 
            v-if="tableShow"
            v-model="tableData" 
            :after-query="firstData" 
            :search="pgData" 
            :lazy="true"
            :action="`${getGetters('mngUrl')}/FaBiao/ZbFile/get_xzjl.json`">
        </my-pagination>
        <div v-if="!tableShow" style="height:500px;text-align:center;margin-top:30px">
            <my-tag type="danger" v-if="sum=='0'"><i class="el-icon-warning"></i>下载招标文件的家数不足{{record}}家！</my-tag>
            <my-tag type="danger" v-if="sum=='1'"><i class="el-icon-warning"></i>下载招标文件的家数大于或等于{{record}}家！</my-tag>
            <my-tag type="danger" v-if="sum=='a'"><i class="el-icon-warning"></i>该项目为匿名项目！</my-tag>
            <my-tag type="danger" v-if="sum=='c'"><i class="el-icon-warning"></i>该项目为保密项目！</my-tag>
            <my-tag type="danger" v-if="sum=='b'"><i class="el-icon-warning"></i>下载招标文件的家数为{{count}}家！</my-tag>
        </div>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

export default {
    mixins: [LIST_PAGE_MIXIN],
    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return{
            pgData: {
                zgys:'',
                sortname:'xzsj',
                procode:this.data.procode,
                id:this.data.id,
            },
            tableShow:true,
            sum:'',
            count:'',
            loading:false,
            record:'',
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        
        //加载列表结束
        firstData(table){
            var that = this;
            table.forEach(function (item,index){
                if(item.zbfilecode!=null&&item.zbfilecode!=""){
                    $.get(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/get_bdname.json`, {
                        zbfilecode:item.zbfilecode,
                        t:Math.random(),
                    }, data => {
                        item.bdname = data.msg;
                        that.$set(table, index, item)
                    });
                }
            })
        },
        exportxls(){
            var zbfilecode = this.data.id;
            window.open(`/common/export/tenderDocumentDownloadRecordXls?tenderFileCode=`+zbfilecode);
        },
    },
    created() {
        
        var that = this
        that.loading = true
        that.jspInit(`${that.getGetters('ageUrl')}/FaBiao/ZbFile/xzjl.json`, {
            id:that.data.id,
            procode:that.data.procode
        }, data => {
            if(data.sum){
                that.sum = data.sum
                that.count = data.count
                that.record = data.record
                that.tableShow = false
                that.loading = false
            }else{
                that.loading = false
                that.$refs.page.queryData(1)
            }
        });
        

    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
    /deep/ .el-tag.el-tag--danger{ font-size: 28px; }
    /deep/ .el-tag--mini{ line-height: 60px; }
</style>
